import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import SidebarMobile from "./SidebarMobile";
import Navbar from "../../components/Navbar/Navbar";

const Dashboard = () => {
  return (
    <div className="flex ">
      <Sidebar className="" />
      <SidebarMobile />
      <div className="z-10 flex-1 h-screen overflow-auto">
        <Navbar />
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
